import { makeStyles } from "tss-react/mui";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

export const ContactListFilter = ({
  items = [],
  selectedValue = null,
  onSelect = () => {},
  showAllOption = true,
  allOptionLabel = "All",
  primaryKey = "name",
  secondaryKey = "type",
  idKey = "id",
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.filterContainer}>
      {showAllOption && (
        <ListItem className={classes.listItem} disablePadding>
          <ListItemButton
            selected={!selectedValue}
            onClick={() => onSelect("")}
            className={classes.listItemButton}
            sx={{ padding: 2 }}
          >
            <ListItemText
              primary={
                <Typography
                  variant="subtitle2"
                  color="textPrimary"
                  fontWeight={600}
                >
                  {allOptionLabel}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
      )}

      <List className={classes.list}>
        {items.map((item) => (
          <ListItem
            key={item[idKey]}
            className={classes.listItem}
            disablePadding
          >
            <ListItemButton
              selected={selectedValue === item[idKey]}
              onClick={() => onSelect(item[idKey])}
              className={classes.listItemButton}
              sx={{ padding: 2 }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="subtitle2"
                    color="textPrimary"
                    fontWeight={600}
                    style={{ wordBreak: "break-all" }}
                  >
                    {item[primaryKey]}
                  </Typography>
                }
                sx={{ margin: 0 }}
                secondary={
                  secondaryKey &&
                  item[secondaryKey] && (
                    <Typography
                      variant="caption"
                      className={classes.secondaryText}
                    >
                      {item[secondaryKey]}
                    </Typography>
                  )
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  filterContainer: {
    height: "100%",
    marginTop: theme.spacing(15),
    borderRadius: theme.shape.borderRadius,
  },
  list: {
    padding: 0,
  },
  listItem: {
    padding: theme.spacing(0),
    margin: theme.spacing(1, 0),
    backgroundColor: "transparent",
    borderTopLeftRadius: theme.spacing(2),
    borderBottomLeftRadius: theme.spacing(2),
  },
  listItemButton: {
    borderTopLeftRadius: theme.spacing(2),
    borderBottomLeftRadius: theme.spacing(2),
    "&:hover": {
      backgroundColor: theme.palette.grey[400],
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.grey[100],
      },
    },
  },
}));
